var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('loader',{attrs:{"extra-class":"full","text":_vm.loadText}}):_vm._e(),(!_vm.loading && _vm.widgetComponent)?_c(_vm.widgetComponent,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }